import { useMutation } from '@tanstack/react-query';

import {
    GtpWalletInfoResult,
    GtpProvisionEvent,
    postMessageRN,
    WebToRNAction,
} from '@eika-infrastruktur/mobilbank-lib';
import { post } from '@eika-infrastruktur/request';

import { useSession } from '@/components/app';
import { KREDITTBANKEN_BASE_URL } from '@/react-query/common';

import { CreditCardGooglePayProvisioningData, CreditCardGooglePayProvisioningResult, Session } from '@generated-types';

import { TOKEN_PROVIDER_VISA } from '../services/DigitalWalletService';
import { GooglePayKbData } from '../types';

const getGooglePayProvisionOPCWithoutSigning = async (
    data: GooglePayKbData,
    walletInfoResult: GtpWalletInfoResult,
    session: Session,
) => {
    const params: CreditCardGooglePayProvisioningData = {
        cardId: data.card.id,
        deviceId: walletInfoResult.deviceStableHardwareId,
        walletId: walletInfoResult.activeWalletId,
        paymentScheme: 'VISA',
    };

    const opc = await post<CreditCardGooglePayProvisioningResult>(
        `${KREDITTBANKEN_BASE_URL}/wallets/google-pay/credit-card-provisioning-data`,
        params,
    );

    const payload: GtpProvisionEvent = {
        opc: opc.digitalizationData,
        cardDisplayName: 'KREDITTKORT',
        cardLastDigits: data.card.cardNumber.slice(-4),
        networkCode: TOKEN_PROVIDER_VISA,
        tokenServiceProviderCode: TOKEN_PROVIDER_VISA,
        userName: `${session.creditProfile?.customer.firstName} ${session.creditProfile?.customer.lastName}`,
        userAddress1: session.creditProfile?.customer.address.address[0],
        userAddress2: session.creditProfile?.customer.address.address[1],
        city: session.creditProfile?.customer.address.city,
        countryCode: session.creditProfile?.customer.address.country,
        postalCode: session.creditProfile?.customer.address.postalCode,
        phoneNumber: session.creditProfile?.customer.contact.mobile,
    };

    postMessageRN({
        action: WebToRNAction.GTP_PUSH_PROVISION,
        payload,
    });
};

const GOOGLE_WALLET_OPC_PROVISION = 'GOOGLE_WALLET_OPC_PROVISION';

export const useV4GooglePayProvisionWithoutSigning = ({
    data,
    walletInfoResult,
}: {
    data: GooglePayKbData;
    walletInfoResult: GtpWalletInfoResult;
}) => {
    const session = useSession();
    return useMutation({
        mutationKey: [GOOGLE_WALLET_OPC_PROVISION, 'v4', walletInfoResult, data],
        mutationFn: () => getGooglePayProvisionOPCWithoutSigning(data, walletInfoResult, session),
    });
};
